import lrCreatetime from './_src/lrCreatetime.vue'

lrCreatetime.install = function(Vue) {
  Vue.component(lrCreatetime.name, lrCreatetime)
}

export default lrCreatetime